/**
 * Footer produces a footer containing two horizontally placed panels.
 * Supported props: src localizerfn
 */
import React from 'react';
import { Link } from 'gatsby';
import LinkMenu from './LinkMenu';
import FbShare from './FbShare';
import TwShare from './TwShare';
import Safe from './Safe';
import logo from '../images/logo_footer.png';

export default function Footer(props) {
  const cfg = props.src;
  const footlinks = (cfg.toplinks || []).concat(cfg.links);
  const thispage = `${cfg.siteurl}${props.location ? props.location.pathname : '/'}`;
  const localized = props.localizerfn;

  return (
    <div id="footer">
      <div className="container-fluid">
        <div className="row">
          <div className="col-sm-5 col-sm-offset-2 footer-left">
            <Link to={localized('/')} id="footer-logo">
              <img src={logo} alt={cfg.sitename} className="img-responsive" />
            </Link>
            <footer className="footer region region-footer" role="contentinfo">
              <div className="block block-block first last odd" id="block-block-1">
                <Safe type="p" content={cfg.text} />
              </div>
            </footer>
          </div>
          <div className="col-sm-3 col-sm-offset-1 share-footer">
            <h3>{cfg.socialLinkLabel}</h3>
            <div className="share-buttons">
              <FbShare pageUrl={thispage} />
              <TwShare pageUrl={thispage} />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-sm-8 col-sm-offset-2">
            <div className="region region-footer-nav">
              <div className="block block-menu-block first last odd" role="navigation" id="block-menu-block-2">
                <div className="menu-block-wrapper menu-block-2 menu-name-main-menu parent-mlid-0 menu-level-1">
                  <LinkMenu links={footlinks} listStyle="footer-menu" localizerfn={localized} />
                  {Array.isArray(cfg.note) &&
                    <div className="text-white">
                      {cfg.note.map((item, index) => <Safe type="p" key={`f_${index}`} className="footnote" content={item} />)}
                    </div>
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
